import { Clipboard } from '@capacitor/clipboard'
import {
    EventrDate,
    formatDate,
    INextComponent,
    IOSMResponseV2,
} from '@eventr/common'
import {
    ColoursObj,
    drawerStore,
    Icon,
    MainButton,
    Typography,
} from '@eventr/common-storybook'
import { TypographyProps } from '@mui/material'
import { LngLat } from 'maplibre-gl'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { DisclosureGroup } from '../../../../common/DisclosureGroup'
import { EventrGatewayAPI } from '../../../../data/gateway.api'
import { useBoundStore } from '../../../../state/bound.store'
import { useLanguageContext } from '../../../../state/languageState/languageContext'
import { useEphemeralStore } from '../../../../state/useEphemeralStore'
import { userPrefShowDestTime } from '../../../../state/userPrefsState/userPrefsSignels'
import { openMobileMapsLink } from '../../../../utils'
import Next from '../../../Next'
import { TeamMember } from '../../../overlay/TeamMember'
import { DirectChatButton } from '../../directChatButton'
import { ItineraryComponents } from '../functions/extractLngLatLabelledItineraryComponents'
import {
    LngLatLabelledAppUser,
    LngLatLabelledItineraryComponents,
} from '../interfaces/locationLabelledObject'

export default function MapDrawer() {
    const {
        mapDrawerIsPresented,
        selectedLngLatLabelledItineraryComponents,
        selectedLngLatLabelledTeamMember,
        closeMapDrawer,
    } = useEphemeralStore(
        useShallow((s) => {
            return {
                mapDrawerIsPresented: s.mapDrawerIsPresented,
                selectedLngLatLabelledItineraryComponents:
                    s.selectedLngLatLabelledItineraryComponents,
                selectedLngLatLabelledTeamMember:
                    s.selectedLngLatLabelledTeamMember,
                closeMapDrawer: s.closeMapDrawer,
            }
        })
    )

    return (
        <div
            style={{
                backgroundColor: ColoursObj.backgrounds.primary,
                borderRadius: mapDrawerIsPresented
                    ? '16px 16px 0px 0px'
                    : '0px 0px 0px 0px',
                transform: `translateY(${
                    mapDrawerIsPresented ? '0px' : `100%`
                })`,
                transition: 'all 0.5s',
                zIndex: 1100,
                left: 0,
                bottom: 0,
                position: 'absolute',
                width: '100%',
                height: selectedLngLatLabelledItineraryComponents
                    ? '50dvh'
                    : '25vh',
            }}
            className="map-drawer"
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'top',
                        padding: '16px',
                        opacity: mapDrawerIsPresented ? 1 : 0,
                        transition: 'opacity 0.5s',
                        gap: '8px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '2px',
                        }}
                    >
                        <MapDrawerTitle
                            selectedLngLatLabelledItineraryComponents={
                                selectedLngLatLabelledItineraryComponents
                            }
                            selectedLngLatLabelledTeamMember={
                                selectedLngLatLabelledTeamMember
                            }
                        />

                        <MapDrawerSubtitle
                            selectedLngLatLabelledItineraryComponents={
                                selectedLngLatLabelledItineraryComponents
                            }
                            selectedLngLatLabelledTeamMember={
                                selectedLngLatLabelledTeamMember
                            }
                        />
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            gap: '8px',
                        }}
                    >
                        <div
                            onClick={() => {
                                closeMapDrawer()
                            }}
                            style={{
                                borderRadius: '20px',
                                padding: '4px',
                                height: '24px',
                                width: '24px',
                                backgroundColor:
                                    ColoursObj.backgrounds.secondary,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Icon name="Exit" />
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        overflowY: 'scroll',
                        height: '100%',
                        opacity: mapDrawerIsPresented ? 1 : 0,
                        transition: 'opacity 0.5s',
                    }}
                >
                    {selectedLngLatLabelledItineraryComponents && (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '16px',
                                    padding: '0px 16px 0px 16px',
                                }}
                            >
                                <MainButton
                                    icon="Map"
                                    size="small"
                                    style={{
                                        width: '100%',
                                    }}
                                    onClick={() => {
                                        openMobileMapsLink(
                                            selectedLngLatLabelledItineraryComponents
                                                .associatedOSMResponse
                                                ?.display_name
                                        )
                                    }}
                                ></MainButton>

                                {/* <MainButton
                                    icon="Share"
                                    variant="secondary"
                                    size="small"
                                    style={{
                                        width: '100%',
                                    }}
                                    onClick={async () => {
                                        await Share.share({
                                            title: 'Share Marked Location',
                                            text: selectedLngLatLabelledItineraryComponents
                                                .associatedOSMResponse
                                                ?.display_name,
                                            url: getMapsUrlFromLngLat(
                                                selectedLngLatLabelledItineraryComponents
                                                    .associatedOSMResponse
                                                    ?.display_name
                                            ),
                                            dialogTitle: 'Share with buddies',
                                        }).catch((e) => {
                                            console.error('Share failed:', e)
                                        })
                                    }}
                                ></MainButton> */}

                                <MainButton
                                    icon="Copy"
                                    size="small"
                                    variant="secondary"
                                    style={{
                                        width: '100%',
                                    }}
                                    onClick={async () => {
                                        await Clipboard.write({
                                            string: selectedLngLatLabelledItineraryComponents
                                                .associatedOSMResponse
                                                ?.display_name,
                                        })
                                    }}
                                ></MainButton>
                            </div>
                            <ItineraryComponentsMapDrawerContent
                                itineraryComponents={
                                    selectedLngLatLabelledItineraryComponents.object
                                }
                            />
                        </>
                    )}

                    {selectedLngLatLabelledTeamMember && (
                        <TeamMemberMapDrawerContent
                            lngLatLabelledTeamMember={
                                selectedLngLatLabelledTeamMember
                            }
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

function MapDrawerTitle({
    selectedLngLatLabelledItineraryComponents,
    selectedLngLatLabelledTeamMember,
}: {
    selectedLngLatLabelledItineraryComponents: LngLatLabelledItineraryComponents
    selectedLngLatLabelledTeamMember: LngLatLabelledAppUser
}) {
    if (
        selectedLngLatLabelledItineraryComponents &&
        selectedLngLatLabelledItineraryComponents.associatedOSMResponse
            ?.display_name
    )
        return (
            <Typography variant="bodyBold">
                {
                    selectedLngLatLabelledItineraryComponents.associatedOSMResponse?.display_name.split(
                        ', '
                    )[0]
                }
            </Typography>
        )

    if (
        selectedLngLatLabelledTeamMember &&
        selectedLngLatLabelledTeamMember.object.firstName &&
        selectedLngLatLabelledTeamMember.object.lastName
    )
        return (
            <Typography variant="bodyBold">{`${selectedLngLatLabelledTeamMember.object.firstName} ${selectedLngLatLabelledTeamMember.object.lastName}`}</Typography>
        )

    return <Typography variant="bodyBold">Marked Location</Typography>
}

function MapDrawerSubtitle({
    selectedLngLatLabelledItineraryComponents,
    selectedLngLatLabelledTeamMember,
}: {
    selectedLngLatLabelledItineraryComponents: LngLatLabelledItineraryComponents
    selectedLngLatLabelledTeamMember: LngLatLabelledAppUser
}) {
    if (
        selectedLngLatLabelledItineraryComponents &&
        selectedLngLatLabelledItineraryComponents.associatedOSMResponse
            ?.display_name
    )
        return (
            <Typography variant="bodySubtext" color={ColoursObj.shades.shade1}>
                {selectedLngLatLabelledItineraryComponents.associatedOSMResponse?.display_name
                    .split(', ')
                    .splice(1)
                    .join(', ')}
            </Typography>
        )

    if (
        selectedLngLatLabelledTeamMember &&
        selectedLngLatLabelledTeamMember.object['timestamp']
    ) {
        const unix = parseFloat(
            selectedLngLatLabelledTeamMember.object['timestamp']
        )

        if (isNaN(unix)) return null

        const relative = new EventrDate(unix)?.userLocalLuxon.toRelative()

        return (
            <>
                <AddressLabel
                    lngLat={selectedLngLatLabelledTeamMember.lngLat}
                />

                <Typography
                    variant="bodySubtext"
                    color={ColoursObj.shades.shade1}
                >
                    {relative}
                </Typography>
            </>
        )
    }

    return null
}

export function AddressLabel({
    lngLat,
    typographyProps,
    maxLength,
}: {
    lngLat: LngLat
    typographyProps?: TypographyProps
    maxLength?: number
}) {
    const [osmResponse, setOSMResponse] = useState<IOSMResponseV2 | null>(null)

    useEffect(() => {
        const fetchOSMAddress = async () => {
            const res = await EventrGatewayAPI.address.reverse(lngLat)

            if (!res.data?.features[0]) return

            setOSMResponse(res.data.features[0])
        }

        fetchOSMAddress()
    }, [])

    return (
        <Typography
            variant="bodySubtext"
            {...typographyProps}
            onClick={() => {
                openMobileMapsLink(
                    `${osmResponse.properties.displayName.replaceAll(' ', '+')}`
                )
            }}
        >
            {formatOSMResponseV2(osmResponse, maxLength)}
        </Typography>
    )
}

function formatOSMResponseV2(res: IOSMResponseV2, maxLength: number): string {
    const components = [
        res?.properties?.name,
        res?.properties?.street,
        res?.properties?.city,
        res?.properties?.state,
        res?.properties?.country,
        res?.properties?.postcode,
    ].filter((item): item is string => item !== undefined)

    if (maxLength) {
        components.splice(maxLength)
    }

    return [...new Set(components)].join(', ')
}

function TeamMemberMapDrawerContent({
    lngLatLabelledTeamMember,
}: {
    lngLatLabelledTeamMember: LngLatLabelledAppUser
}) {
    const openItinerary = useCallback(() => {
        useBoundStore
            .getState()
            .setOverride(lngLatLabelledTeamMember.object.id, false)

        drawerStore().openDrawer({
            node: <TeamMember />,
        })
    }, [lngLatLabelledTeamMember])

    const { getCurrentUser } = useBoundStore(
        useShallow((s) => {
            return {
                getCurrentUser: s.getCurrentUser,
            }
        })
    )

    const currentUser = getCurrentUser()

    return (
        <div
            style={{
                padding: '16px',
                gap: '16px',
                display: 'flex',
                flexDirection: 'row',
            }}
        >
            <div
                style={{
                    width: '100%',
                }}
            >
                <DirectChatButton
                    fullWidth
                    user_id={currentUser.id}
                    user_id2={lngLatLabelledTeamMember.object.id}
                />
            </div>

            <div
                style={{
                    width: '100%',
                }}
            >
                <MainButton
                    style={{
                        width: '100%',
                    }}
                    icon="Itinerary"
                    iconPosition="left"
                    onClick={openItinerary}
                >
                    Itinerary
                </MainButton>
            </div>
        </div>
    )
}

function ItineraryComponentsMapDrawerContent({
    itineraryComponents,
}: {
    itineraryComponents: ItineraryComponents
}) {
    const { getLanguageISO639Code } = useLanguageContext()

    const { selectedItinEmpty } = useBoundStore(
        useShallow((s) => {
            return {
                selectedItinEmpty: s.selectedItinEmpty,
            }
        })
    )

    const [showPast, setShowPast] = useState(false)

    const components: {
        [key: string]: INextComponent[]
    } = useMemo(() => {
        return showPast ? itineraryComponents.past : itineraryComponents.present
    }, [itineraryComponents, showPast])

    return (
        <>
            {Object.keys(components)
                .filter((key) => {
                    return key !== 'Other'
                })
                .map((key, index) => {
                    return (
                        <DisclosureGroup
                            key={index}
                            containerStyle={{
                                backgroundColor: ColoursObj.backgrounds.primary,
                            }}
                            title={
                                key !== 'Other'
                                    ? formatDate(
                                          components[key][0].date,
                                          userPrefShowDestTime.value,
                                          getLanguageISO639Code()
                                      )
                                    : key
                            }
                            isOpen={true}
                            count={components[key].length}
                            icon={
                                <Icon
                                    name="Calendar"
                                    iconColour={ColoursObj.backgrounds.primary}
                                    bubble
                                />
                            }
                            content={<Next components={components[key]} />}
                        />
                    )
                })}
            {components['Other'] &&
                components['Other'].length !== 0 &&
                !selectedItinEmpty && (
                    <DisclosureGroup
                        title={'Other'}
                        isOpen={true}
                        containerStyle={{
                            backgroundColor: ColoursObj.backgrounds.primary,
                        }}
                        count={components['Other'].length}
                        icon={
                            <Icon
                                name="Calendar"
                                iconColour={ColoursObj.backgrounds.primary}
                                bubble
                            />
                        }
                        content={<Next components={components['Other']} />}
                    />
                )}

            {Object.keys(itineraryComponents.past).length !== 0 && (
                <div
                    style={{
                        padding: '16px',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="bodySubtext"
                        align="center"
                        color={ColoursObj.core.secondary}
                        onClick={() => setShowPast(!showPast)}
                    >
                        See {showPast ? 'present' : 'past'} entries
                    </Typography>
                </div>
            )}
        </>
    )
}
